export const emailRegex = /^[\w-\\.]+@([\w-]+\.)+[\w-]{2,4}$/
export const numberRegex = /[1-9]/
export const cuitRegex = /^\d{2}-\d{8}-\d{1}$/
export const cuitRegexNoDashes = /^\d{11}$/
export const renspaRegex = /^(\d{2}\.){2}\d{1}\.\d{5}\/\d{2}$/
export const CUIGRegex = /^[A-Za-z]{2}[0-9]{3}$/